import { render, staticRenderFns } from "./step-component.vue?vue&type=template&id=519402ee&scoped=true&"
import script from "./step-component.vue?vue&type=script&lang=js&"
export * from "./step-component.vue?vue&type=script&lang=js&"
import style0 from "./step-component.vue?vue&type=style&index=0&id=519402ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519402ee",
  null
  
)

export default component.exports